export interface GlobalConfig {
  AUTH_ENABLED: any;
  AUTH_TOKEN_GENERATOR_URL: any;
  HOST: any;
  DISABLE_EVENTS: any;
  DEBUG_EVENTS: any;
  EVENTS_KINESIS_STREAM_NAME: any;
  EVENTS_KINESIS_ENDPOINT: any;
  IMAGE_TAG: any;
  GOOGLE_ADWORDS_CONVERSION_ID_NEW: any;
  GOOGLE_ADWORDS_CONVERSION_ID_OLD: any;
}

export function getGlobalConfig(): GlobalConfig {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-underscore-dangle
    return window.__ENV__ as GlobalConfig;
  }

  return {
    AUTH_ENABLED: process.env.AUTH_ENABLED,
    AUTH_TOKEN_GENERATOR_URL: process.env.AUTH_TOKEN_GENERATOR_URL,
    HOST: process.env.HOST,
    DISABLE_EVENTS: process.env.DISABLE_EVENTS,
    DEBUG_EVENTS: process.env.DEBUG_EVENTS,
    EVENTS_KINESIS_STREAM_NAME: process.env.EVENTS_KINESIS_STREAM_NAME,
    EVENTS_KINESIS_ENDPOINT: process.env.EVENTS_KINESIS_ENDPOINT,
    IMAGE_TAG: process.env.IMAGE_TAG,
    GOOGLE_ADWORDS_CONVERSION_ID_NEW: process.env.GOOGLE_ADWORDS_CONVERSION_ID_NEW,
    GOOGLE_ADWORDS_CONVERSION_ID_OLD: process.env.GOOGLE_ADWORDS_CONVERSION_ID_OLD,
  };
}
